import React, { useEffect } from "react";
import { useField, Field, ErrorMessage, useFormikContext } from "formik";
import IntlMessages from "components/Utils/intlMessages";

const styles = {
  label: "text-white text-sm  ltr:font-gotham-medium rtl:font-semibold",
  field:
    "border border-gray-80 text-dark focus:outline-none focus:shadow-outline py-1 w-full rounded appearance-none",
  option: "flex gap-2 items-center",
  errorMsg: "text-error-50 text-4xs leading-3 pt-2 pb-1",
  fieldError:
    "border text-sm text-dark bg-error-50 focus:outline-none focus:shadow-outline focus:ring-error-900  py-2 w-full rounded appearance-none border-error-900",
};

function RadioTextOption(props) {
  const { buttonStyled, label, errors, touched, name, options, ...rest } =
    props;
  const [field, meta] = useField(name);
  const formik = useFormikContext(); // Access the formik context

  useEffect(() => {
    if (field.value === undefined) {
      formik.setFieldValue(name, ""); // Initialize the field value as an empty string if it's undefined
    }
  }, [field.value, formik.setFieldValue, name]);

  return (
    <div className={`w-full flex gap-5`}>
      <div className="flex items-center justify-between">
        <label className={styles.label} htmlFor={name}>
          {label}
        </label>
      </div>

      <Field
        className={touched && errors ? styles.fieldError : styles.field}
        id={name}
        name={name}
      >
        {({ field }) => {
          return options?.map((option) => {
            const isChecked = field.value === option.id;

            return (
              <div
                className={`${styles.option} ${
                  buttonStyled ? "bg-gray-30 rounded-full px-4 py-2" : ""
                }`}
                key={option.id}
              >
                <input
                  type="radio"
                  id={option.id}
                  {...field}
                  {...rest}
                  style={{ position: "absolute", opacity: 0 }} // Hide the radio button visually
                  value={option.id}
                  checked={isChecked}
                  onChange={() => {
                    if (!isChecked) {
                      formik.setFieldValue(name, option.id);
                    }
                  }}
                />
                {option.icon}
                <label
                  className={styles.label + " " + "!font-gotham-regular"}
                  htmlFor={option.id}
                >
                  {option.name}
                </label>
              </div>
            );
          });
        }}
      </Field>
      <ErrorMessage component="p" className={styles.errorMsg} name={name} />
    </div>
  );
}

export default RadioTextOption;
